var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconControlPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.508 0C22.372 0 23 .692 23 1.646v20.723c0 1.07-.738 1.632-1.47 1.632-.31 0-.619-.094-.917-.278L3.332 13.022a2.068 2.068 0 01-.333-.261v10.246a1 1 0 11-2 0v-22a1 1 0 012 0v9.538c.107-.103.23-.196.369-.276L20.625.252A1.75 1.75 0 0121.508 0zM21 2.347l-16.058 9.32L21 21.609V2.347z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconControlPrevious;